module.exports = __webpack_public_path__ + "static/media/pic7.3d013f6e.jpg";